import api from './client';
import { Bird } from './birds';

export interface HealthTest {
  id: string;
  testName: string;
  testeeName: string;
  testDate: string;
  result: string;
  comment?: string;
  description?: string;
  cost: number;
  notes?: string;
  birdId: string;
  bird?: Bird;
  // Temporarily commented out until database schema is fixed
  // documents?: {
  //   id: string;
  //   url: string;
  //   type: string;
  //   dateAdded: string;
  // }[];
  createdAt: string;
  updatedAt: string;
}

export interface CreateHealthTestDto {
  testName: string;
  testeeName: string;
  testDate: string;
  result?: string;
  comment?: string;
  description?: string;
  cost: number;
  notes?: string;
  birdId: string;
}

export interface UpdateHealthTestDto {
  testName?: string;
  testeeName?: string;
  testDate?: string;
  result?: string;
  comment?: string;
  description?: string;
  cost?: number;
  notes?: string;
}

export interface HealthTestFilters {
  testName?: string;
  testeeName?: string;
  result?: string;
  birdId?: string;
  dateRange?: {
    start: string;
    end: string;
  };
  costRange?: {
    min: number;
    max: number;
  };
}

export const healthTestsApi = {
  getHealthTests: () => api.get<HealthTest[]>('health-tests'),
  getAll: () => api.get<HealthTest[]>('health-tests'),
  getById: (id: string) => api.get<HealthTest>(`health-tests/${id}`),
  create: (data: CreateHealthTestDto) => api.post<HealthTest>('health-tests', data),
  update: (id: string, data: UpdateHealthTestDto) => api.put<HealthTest>(`health-tests/${id}`, data),
  delete: (id: string) => api.delete(`health-tests/${id}`),
  getByBirdId: (birdId: string) => api.get<HealthTest[]>(`birds/${birdId}/health-tests`),
};

// Common health test types for dropdown options
export const COMMON_HEALTH_TESTS = [
  'Blood Test',
  'Fecal Examination',
  'Crop Swab',
  'Chlamydia Test',
  'Polyomavirus Test',
  'PBFD Test',
  'Beak and Feather Disease',
  'Avian Influenza',
  'Newcastle Disease',
  'Salmonella Test',
  'E. coli Test',
  'Candida Test',
  'Aspergillosis Test',
  'Parasitology',
  'Radiography',
  'Endoscopy',
  'DNA Sexing',
  'General Health Check',
  'Vaccination',
  'Other'
];

// Common test results
export const COMMON_TEST_RESULTS = [
  'Negative',
  'Positive',
  'Normal',
  'Abnormal',
  'Pending',
  'Inconclusive',
  'Within Normal Limits',
  'Elevated',
  'Low',
  'Critical',
  'Requires Follow-up'
]; 